import { globalVal } from '../../../global/globalvalues';
import image1 from '../../../Assets/images/PostActivation/Services/Path.svg';
import image2 from '../../../Assets/images/PostActivation/Services/call.svg';
import image3 from '../../../Assets/images/PostActivation/Services/Shape.svg';

export const servicesPage: any = {
    overlay: 'Services',
    internationalServicesText: `<ul><li>Stay connected while traveling the world with International Roaming.</li><li>Call & text the world from the U.S. with International Calling.</li></ul>`,
    exploreInternationaServices: ``,
    manageLineText: `Need more data or want to change plan?<br> 
    Manage your service effortlessly from the ${globalVal && globalVal.long_name} App/Website.<br><br><br><br><br><br>`,
    manageLineExploreText: ``,
};

export const astoundServicesPage: any = {
    overlay: 'Services',
    mainPage: [
        {
            title: 'International Roaming',
            img: image1,
            text: 'Stay connected while you travel abroad.',
            btnText: 'MANAGE',
            shortName: 'IR',
            alt: 'Flight icon',
        },
        {
            title: 'International Calling',
            img: image2,
            text: 'Call anywhere in the world, from the U.S.',
            btnText: 'MANAGE',
            shortName: 'ILD',
            alt: 'Call icon'
        },
        {
            title: 'Domestic Roaming',
            img: image3,
            text: 'Stay connected anywhere in the U.S.',
            btnText: 'MANAGE',
            shortName: 'DR',
            alt: 'American flag icon'
        },
    ],
};
export const ILD: any = {
    heading: 'Call the World from the U.S. & Pay-As-You-Go',
    listItems: [
        'Enable International Calling service at no extra cost.',
        'International SMS is free of cost.',
        'Search the rates for country of choice for voice calling.',
    ],
    historyKey: 'Country',
    historyVal: 'Usage (mins)',
}
export const IR: any = {
    heading: 'Roaming Perks Without the Daily Fees!',
    listItems: [
        'Stay connected while you travel the world.',
        'Enable International Roaming yourself on the day of travel at no extra cost.',
        'Voice, SMS & Data will be charged on a pay-as-you-go basis.',
    ],
    countriesTxt: 'Countries: ',
    historyKey: 'Usage units',
    historyVal: 'Usage',
}
export const DR: any = {
    heading: 'Roaming Within U.S. With Ease!',
    desc: `Travel across the country and stay connected even when you're outside 
            Astound Mobile's coverage areas. Flat pricing is applicable, across the U.S., 
            charged at the end of your billing cycle.`,
    historyKey: 'Usage units',
    historyVal: 'Usage',
}